<template>
	<div class="nobr updated-container">
		<span v-if="label" :class="labelClass" :title="tooltipText">
			<WarningFilled v-if="valueIsOld" />
			{{ label }}
		</span>
		<span v-else-if="valueIsOld" class="alert-icon-old" :title="tooltipText">
			<WarningFilled />
		</span>
		<span :class="datetimeClass">
			<span v-if="currentDatetime" :title="tooltipText">
				{{ $t('home-map.tooltip.labels.updated') }}
				<DateTimeDisplay :date="currentDatetime" :format="'YYYY-MM-DD HH:mm:ss'" />
			</span>
			<span v-else>
				{{ $t('home-map.tooltip.labels.noUpdates') }}
			</span>
		</span>
	</div>
</template>

<script lang="ts">
import { toRef, computed } from 'vue';
import type { PropType } from 'vue';
import { WarningFilled } from '@ant-design/icons-vue';

import { useI18n } from 'vue-i18n';

import Consts from '@/api/Consts';

import DateTimeDisplay from '@/components/common/DateTimeDisplay.vue';

export default {
	components: { DateTimeDisplay, WarningFilled },
	props: {
		label: {
			type: String,
			required: false,
		},
		currentDatetime: {
			type: [Date, String] as PropType<Date | string | null | undefined>,
			required: false,
		},
		valueIsOld: {
			type: Boolean,
			required: false,
		},
	},
	setup(props) {
		const { t } = useI18n();
		const valueIsOldRef = toRef(props, 'valueIsOld');
		const labelClass = computed(() => {
			return valueIsOldRef.value ? 'updated-label-old' : 'updated-label';
		});
		const datetimeClass = computed(() => {
			return valueIsOldRef.value ? 'updated-datetime-old' : 'updated-datetime';
		});
		const tooltipText = computed(() => {
			return valueIsOldRef.value ? t('home-map.tooltip.labels.oldData') : '';
		});
		return {
			valueIsOldRef,
			labelClass,
			datetimeClass,
			tooltipText,
			gray: Consts.COLORS.gray,
			pink: Consts.COLORS.pink,
		};
	},
}
</script>

<style scoped>
.updated-container {
	font-size: 9px;
	margin-top: 8px;
}

.updated-label, .updated-label-old {
	color: white;
	background-color: v-bind(gray);
	padding: 2px;
	padding-inline-end: 3px;
	margin-inline-end: 4px;
}

.updated-label-old {
	color: white;
	background-color: v-bind(pink);
}

.alert-icon-old {
	color: v-bind(pink);
	background-color: white;
	margin-inline-end: 4px;
}

.updated-datetime {
	color: v-bind(gray);
}

.updated-datetime-old {
	color: v-bind(pink);
}

</style>